import { AccentCardVariant } from '@/components/AccentCard/AccentCard.vue';
import { LoginMethodHeaderVariant } from '@/components/LoginMethodHeader/LoginMethodHeader.vue';
import { SsoProvider } from '@/generated/graphql';

export function getSsoAccentCardVariant(provider: SsoProvider): AccentCardVariant {
    if (provider === SsoProvider.SsoKm) {
        return 'Koelnmesse';
    }
    return 'Yellow';
}

export function getLoginMethodHeaderVariant(provider?: SsoProvider): LoginMethodHeaderVariant {
    if (provider) {
        if (provider === SsoProvider.SsoKm) {
            return 'Koelnmesse-SSO';
        }
        return 'Generic-SSO';
    }
    return 'Developer-Account';
}
